
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import "../assets/css/login.css";
import logo from "../assets/images/logo.svg";
import { encode } from "hex-encode-decode";
import { IoCall, IoLockClosed, IoWarning } from "react-icons/io5";
import config from "../api/config";
//

export default function Login() {
  // fields
  const [username, setUserName] = useState(localStorage.getItem("name") || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const navigate = useHistory();
  // request login
  const loginUser = async (body) => {
    try {
      const res = await config.post(`/api/auth/v1/login`, body);

      if (res?.data?.objectKoinot) {
        localStorage.setItem("auth", encode(res.data.objectKoinot.accessToken));
        localStorage.setItem("login", encode("true"));
        localStorage.setItem(
          "role",
          encode(JSON.stringify(res.data.objectKoinot.roles))
        );
        navigate.push("/");
        window.location.reload();
      }
    } catch (error) {
      setError(true);
    }
  };
  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    await loginUser({
      phoneNumber: username,
      password,
    });
  };
  return (
    <div className="all_container">
      <div className="login_topnav d-flex justify-content-between align-items-center">
        <div className="login_topnav__logo d-flex align-items-center">
          <img src={logo} alt="company logo" />
          <h2 style={{ margin: "20px" }}>TeleGogle</h2>
        </div>
        <div className="login_topnav__link">
          <Link to="/about">О проекте</Link>
        </div>
      </div>
      <div className="login_container">
        <div className="wrapper">
          <header>Логин</header>
          <form action="#" onSubmit={handleSubmit}>
            <div className="field email">
              <div className="input-area">
                <input
                  type="text"
                  placeholder="Номер телефона"
                  onChange={(e) => {
                    setUserName(e.target.value);
                  }}
                />
                <IoCall className="icon" />
              </div>
            </div>
            <div className="field password">
              <div className="input-area">
                <input
                  type="password"
                  placeholder="Пароль"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <IoWarning
                  className="error error-icon fas fa-exclamation-circle"
                  style={{ display: error ? "block" : "none" }}
                />
                <IoLockClosed className="icon" />
              </div>
              <div
                className="error error-txt"
                style={{ display: error ? "block" : "none" }}
              >
                Неправильный пароль или номер
              </div>
              <Link
                className="pass-txt my-5 curosr-pointer mt-4"
                to="/verify?mode=forgot"
              >
                Забыли пароль?
              </Link>
            </div>

            <input type="submit" value="Войти" />
          </form>
          <div className="sign-txt">
            Еще не участник? <br />
            <Link to="/register"> Зарегистрируйтесь сейчас</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
